import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

export function useBreakpoint() {
  const breakpointObserver = inject(BreakpointObserver);

  const breakpoints$ = breakpointObserver.observe([
    Breakpoints.XSmall,
    Breakpoints.Small,
    Breakpoints.Medium,
    Breakpoints.Large,
    Breakpoints.XLarge,
  ]);

  const breakpointsSignal = toSignal(breakpoints$, {
    initialValue: {
      matches: false,
      breakpoints: {} as Record<string, boolean>,
    },
  });

  const currentBreakpoint = computed(() => {
    const bp = breakpointsSignal().breakpoints;
    if (bp[Breakpoints.XSmall]) return 'XSmall';
    if (bp[Breakpoints.Small]) return 'Small';
    if (bp[Breakpoints.Medium]) return 'Medium';
    if (bp[Breakpoints.Large]) return 'Large';
    if (bp[Breakpoints.XLarge]) return 'XLarge';
    return 'Unknown';
  });

  return {
    currentBreakpoint,
  };
}
